import axios from 'axios';

import { assertClientSide } from '@dr.pogodin/react-utils';

import type {
  CreateResearchLibLinkBodyT,
  CreateResearchLibLinkResT,
} from 'server/controllers/researchLib';

import { P_API_RESEARCH_LIB_LINKS, type ResearchLibLinkT, getConfig } from 'utils';

type CreateResearchLibLinkArgT = {
  category: string;
  highlights: string;
  text: string;
  url: string;
};

export async function createResearchLibLink({
  category,
  highlights,
  text,
  url,
}: CreateResearchLibLinkArgT): Promise<ResearchLibLinkT> {
  assertClientSide();

  const config = await getConfig();

  const res = await axios.post<CreateResearchLibLinkResT>(
    P_API_RESEARCH_LIB_LINKS,
    {
      _csrf: config.CSRF,
      category,
      highlights,
      text,
      url,
    } satisfies CreateResearchLibLinkBodyT,
  );

  return res.data;
}
